/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";

import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Dropdown from "./dropdown";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  background: "#ddeff3",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "14px " }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th
      {...rest}
      style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400, fontSize: "14px" }}
    >
      {children}
    </th>
  );
};
const defaultOption = [
  {
    value: "title",
    label: "title",
    disabled: true,
  },
];

const wineSymbolOption = [
  {
    value: "TR02T",
    label: "TR02T",
    disabled: false,
  },
  {
    value: "TR02C",
    label: "TR02C",
    disabled: false,
  },
  {
    value: "TR01C",
    label: "TR01C",
    disabled: false,
  },
  {
    value: "TR01T",
    label: "TR01T",
    disabled: false,
  },
  {
    value: "TR01R",
    label: "TR01R",
    disabled: false,
  },
];

const dataTable = [
  {
    id: {
      value: uuidV4(),
      bg: true,
    },

    recordDate: {
      type: "date",
      label: "Ngày, tháng ghi sổ",
      value: null,
      bg: false,
    },

    voucherNumber: {
      type: "input",
      label: "Số hiệu chứng từ",
      value: null,
      bg: false,
    },

    voucherDate: {
      type: "date",
      label: "Ngày, tháng chứng từ",
      value: null,
      bg: false,
    },

    description: {
      type: "input",
      label: "Diễn giải",
      value: "Số trang trước chuyển sang",
      bg: false,
    },

    posted: {
      type: "checkbox",
      label: "Đã ghi sổ cái",
      value: false,
      bg: false,
    },

    rowIndex: {
      type: "number",
      label: "STT dòng",
      value: 1,
      bg: false,
    },

    offsetAccount: {
      type: "input",
      label: "Số hiệu TK đối ứng",
      value: null,
      bg: false,
    },

    debit: {
      type: "number",
      label: "Nợ",
      value: 0,
      bg: false,
    },

    credit: {
      type: "number",
      label: "Có",
      value: 0,
      bg: false,
    },
  },
];

export default function WineTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const getMaxIdValue = () => {
    return Math.max(...data.map((item) => item.id.value), 0);
  };

  const addNewRow = () => {
    const newIdValue = getMaxIdValue() + 1;
    const newRow = {
      id: {
        value: uuidV4(),
        bg: true,
      },

      recordDate: {
        type: "date",
        value: null,
        bg: true,
      },

      voucherNumber: {
        type: "input",
        value: null,
        bg: true,
      },

      voucherDate: {
        type: "date",
        value: null,
        bg: false,
      },

      description: {
        type: "input",
        value: null,
        bg: false,
      },

      posted: {
        type: "checkbox",
        value: false,
        bg: false,
      },

      rowIndex: {
        type: "number",
        value: 0,
        bg: false,
      },

      offsetAccount: {
        type: "input",
        value: null,
        bg: false,
      },

      debit: {
        type: "number",
        value: 0,
        bg: false,
      },

      credit: {
        type: "number",
        value: 0,
        bg: false,
      },
    };

    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Grid item xs={12} style={{ paddingTop: 0 }}>
        <Typography component="label" variant="caption" fontWeight="bold" fontSize={14}>
          3 Các loại hóa đơn khác
        </Typography>
      </Grid>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th rowSpan={2} style={{ textAlign: "center", verticalAlign: "middle" }}>
                Ngày, tháng ghi sổ
              </Th>
              <Th colSpan={2} style={{ textAlign: "center" }}>
                Chứng từ
              </Th>
              <Th rowSpan={2} style={{ textAlign: "center", verticalAlign: "middle" }}>
                Diễn giải
              </Th>
              <Th rowSpan={2} style={{ textAlign: "center", verticalAlign: "middle" }}>
                Đã ghi sổ cái
              </Th>
              <Th rowSpan={2} style={{ textAlign: "center", verticalAlign: "middle" }}>
                STT dòng
              </Th>
              <Th rowSpan={2} style={{ textAlign: "center", verticalAlign: "middle" }}>
                Số hiệu TK đối ứng
              </Th>
              <Th colSpan={2} style={{ textAlign: "center" }}>
                Số phát sinh
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>Số hiệu</Th>
              <Th style={{ textAlign: "center" }}>Ngày, tháng</Th>
              <Th style={{ textAlign: "center" }}>Nợ</Th>
              <Th style={{ textAlign: "center" }}>Có</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>A</Th>
              <Th style={{ textAlign: "center" }}>B</Th>
              <Th style={{ textAlign: "center" }}>C</Th>
              <Th style={{ textAlign: "center" }}>D</Th>
              <Th style={{ textAlign: "center" }}>E</Th>
              <Th style={{ textAlign: "center" }}>G</Th>
              <Th style={{ textAlign: "center" }}>H</Th>
              <Th style={{ textAlign: "center" }}>I</Th>
              <Th style={{ textAlign: "center" }}>2</Th>
            </tr>
          </thead>
          <tbody style={{ backgroundColor: "#fff" }}>
            {data?.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  {/* Ngày, tháng ghi sổ */}
                  <Td row={row} style={{ textAlign: "center", background: "transparent" }}>
                    <InputTable
                      type="date"
                      id={row.id.value}
                      name="recordDate"
                      value={row.recordDate.value}
                      onChange={handleChange}
                    />
                  </Td>

                  {/* Số hiệu chứng từ */}
                  <Td row={row} style={{ textAlign: "center", background: "transparent" }}>
                    <InputTable
                      type="text"
                      id={row.id.value}
                      name="voucherNumber"
                      value={row.voucherNumber.value}
                      onChange={handleChange}
                    />
                  </Td>

                  {/* Ngày, tháng chứng từ */}
                  <Td row={row} style={{ textAlign: "center", background: "transparent" }}>
                    <InputTable
                      type="date"
                      id={row.id.value}
                      name="voucherDate"
                      value={row.voucherDate.value}
                      onChange={handleChange}
                    />
                  </Td>

                  {/* Diễn giải */}
                  <Td row={row} style={{ textAlign: "left", background: "transparent" }}>
                    <InputTable
                      type="text"
                      id={row.id.value}
                      name="description"
                      value={row.description.value}
                      onChange={handleChange}
                    />
                  </Td>

                  {/* Đã ghi sổ cái */}
                  <Td row={row} style={{ textAlign: "center", background: "transparent" }}>
                    <input
                      type="checkbox"
                      checked={row.posted.value}
                      onChange={(e) =>
                        handleChange({
                          id: row.id.value,
                          name: "posted",
                          value: e.target.checked,
                        })
                      }
                    />
                  </Td>

                  {/* STT dòng */}
                  <Td row={row} style={{ textAlign: "center", background: "transparent" }}>
                    <InputTable
                      type="number"
                      id={row.id.value}
                      name="rowIndex"
                      value={row.rowIndex.value}
                      onChange={handleChange}
                    />
                  </Td>

                  {/* Số hiệu TK đối ứng */}
                  <Td row={row} style={{ textAlign: "left", background: "transparent" }}>
                    <InputTable
                      type="text"
                      id={row.id.value}
                      name="offsetAccount"
                      value={row.offsetAccount.value}
                      onChange={handleChange}
                    />
                  </Td>

                  {/* Nợ */}
                  <Td row={row} style={{ textAlign: "right", background: "transparent" }}>
                    <InputTable
                      type="number"
                      id={row.id.value}
                      name="debit"
                      min={0}
                      value={row.debit.value}
                      onChange={handleChange}
                    />
                  </Td>

                  {/* Có */}
                  <Td row={row} style={{ textAlign: "right", background: "transparent" }}>
                    <InputTable
                      type="number"
                      id={row.id.value}
                      name="credit"
                      min={0}
                      value={row.credit.value}
                      onChange={handleChange}
                    />
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, fields, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      type={fields}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
